import React, { useState } from 'react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';
import { Menu, Phone, Mail } from 'lucide-react';
import { mockData } from '../mock';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const logoUrl = 'https://customer-assets.emergentagent.com/job_technikwegele/artifacts/vmv43psx_Gemini_Generated_Image_6fmu906fmu906fmu.png';

  const navigation = [
    { name: 'Startseite', href: '#home' },
    { name: 'Leistungen', href: '#services' },
    { name: 'Projekte', href: '#projects' },
    { name: 'Kontakt', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-b from-[#0a1632]/90 to-[#0a1632]/70 backdrop-blur-sm border-b border-white/5">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-28 md:h-32 lg:h-36">
          {/* Logo - Bigger Image, Smaller Text */}
          <div className="flex items-center space-x-4">
            <img 
              src={logoUrl} 
              alt="Elektrotechnik Wegele Logo" 
              className="h-24 md:h-32 lg:h-36 w-auto drop-shadow-2xl"
            />
            <div className="block">
              <h1 className="text-white font-bold text-lg md:text-xl lg:text-2xl leading-tight drop-shadow-lg">
                ELEKTROTECHNIK<br/>
                <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
                  WEGELE
                </span>
              </h1>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigation.map((item) => (
              <button
                key={item.name}
                onClick={() => scrollToSection(item.href)}
                className="text-white/80 hover:text-white transition-colors duration-300 font-medium"
              >
                {item.name}
              </button>
            ))}
          </nav>

          {/* Contact Info & CTA */}
          <div className="hidden xl:flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-sm text-white/80">
              <Phone className="h-4 w-4" />
              <span>{mockData.contact.phone}</span>
            </div>
            <Button 
              onClick={() => scrollToSection('#contact')}
              className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white border-0 shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105"
            >
              Jetzt anfragen
            </Button>
          </div>

          {/* Mobile Menu */}
          <div className="lg:hidden">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="sm" className="text-white hover:bg-white/10">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="bg-[#0a1632] border-white/10">
                {/* Mobile Logo */}
                <div className="flex items-center space-x-3 mb-8 pt-4">
                  <img 
                    src={logoUrl} 
                    alt="Elektrotechnik Wegele Logo" 
                    className="h-20 w-auto"
                  />
                  <div>
                    <h2 className="text-white font-bold text-base leading-tight">
                      ELEKTROTECHNIK<br/>
                      <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 bg-clip-text text-transparent">
                        WEGELE
                      </span>
                    </h2>
                  </div>
                </div>
                <div className="flex flex-col space-y-4">
                  {navigation.map((item) => (
                    <button
                      key={item.name}
                      onClick={() => scrollToSection(item.href)}
                      className="text-white hover:text-cyan-400 transition-colors duration-300 text-left py-3 text-lg font-medium"
                    >
                      {item.name}
                    </button>
                  ))}
                  <div className="pt-4 border-t border-white/10">
                    <div className="flex items-center space-x-2 text-white/80 mb-4">
                      <Phone className="h-4 w-4" />
                      <span>{mockData.contact.phone}</span>
                    </div>
                    <div className="flex items-center space-x-2 text-white/80 mb-6">
                      <Mail className="h-4 w-4" />
                      <span>{mockData.contact.email}</span>
                    </div>
                    <Button 
                      onClick={() => scrollToSection('#contact')}
                      className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white border-0"
                    >
                      Jetzt anfragen
                    </Button>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;